import deleteRedFill from './icons/delete-red-fill.svg'
import calendarSmallDark from './icons/calendar-small-dark.svg'
import recycle from './icons/Recycle.svg'
import heart from './icons/Heart.svg'
import warningRed from './icons/warning-red.svg'
import fail from './icons/fail.svg'
import closeSmallBlack from './icons/close-small-black.svg'
import copyPrimary from './icons/copy-primary.svg'
import circlePlus from './icons/circle-plus.svg'
import send from './icons/send.svg'
import gallery from './icons/gallery.svg'
import noChat from './icons/No-Chat-History.svg'
import orangeInfo from './icons/Info -Square-orange.svg'
import purpuleInfo from './icons/Info-Square-purpule.svg'
import defaultInfo from './icons/Info-Square-default.svg'
import Back from './icons/back.svg'
import Avatar from './icons/avatar.svg'
import station from './icons/station.svg'
import stationActive from './icons/station-active.svg'
import account from './icons/account.svg'
import accountActive from './icons/account-active.svg'
import reservationList from './icons/reservation-list.svg'
import reservationListActive from './icons/reservation-list-active.svg'
import vehicle from './icons/vehicle.svg'
import vehicleActive from './icons/vehicle-active.svg'
import menu from './icons/menu.svg'
import close from './icons/close.svg'
import collapse from './icons/collapse.svg'
import deleteRed from './icons/delete-red.svg'
import calendar from './icons/calendar.svg'
import edit from './icons/edit.svg'
import primaryEdit from './icons/primary-edit.svg'
import circleSuccess from './icons/circle-success.svg'
import circleInfoYellow from './icons/circle-info.svg'
import emptyFolder from './icons/empty-folder.svg'
import calendarLarge from './icons/calendar-large.svg'
import successImage from './icons/success-image.svg'
import failImage from './icons/fail-image.svg'
import stationLarge from './icons/station-large.svg'
import vehicleLarge from './icons/vehicle-large.svg'
import vehicleExtraLarge from './icons/vehicle-extra-large.svg'
import arrowLeftPrimary from './icons/arrow-left-primary.svg'
import calendarGray from './icons/calendar-gray.svg'
import hourGlass from './icons/hour-glass.svg'
import emptyCalendar from './icons/empty-calendar.svg'
import whiteLeft from './icons/whiteLeft.svg'
import iran from './icons/iran.svg'
import clockSmall from './icons/clock-small.svg'
import phoneSmall from './icons/phone-small.svg'
import locationSmall from './icons/location-small.svg'
import location from './icons/location.svg'
import phone from './icons/phone.svg'
import truck from './icons/truck.svg'
import closeSquare from './icons/close-square.svg'
import tickSquare from './icons/tick-square.svg'
import arrowLeft from './icons/arrow-left.svg'
import arrowRight from './icons/arrow-right.svg'
import getTurn from './icons/get-turn.svg'
import RedLeft from './icons//red-left.svg'
import RedWarning from './icons/red-warning.svg'
import TwoCircles from './icons/two-circles.svg'
import Warning from './icons/warning.svg'
import Eye from './icons/eye.svg'
import walletPrimary from './icons/wallet-primary.svg'
import plusPrimary from './icons/plus-primary.svg'
import plusWhite from './icons/plus-white.svg'
import minusPrimary from './icons/minus-primary.svg'
import guideCard from './icons/guide-card.png'
import guideCardEzpay from './icons/guide-card-ezpay.png'
import repeat from './icons/repeat.svg'
import Home from './icons/home.svg'
import Wallet from './icons/wallet.svg'
import CalendarWhite from './icons/calendar-white.svg'
import FilledHome from './icons/filled-home.svg'
import FilledCalendar from './icons/filled-calendar.svg'
import FilledWallet from './icons/filled-wallet.svg'
import emptyCard from './icons/empty-card.svg'
import exitRed from './icons/exit-red.svg'
import marketPlaceholder from './icons/market-placeholder.svg'
import subway from './icons/subway.svg'
import locationSquare from './icons/location-square.svg'
import locationSmallDark from './icons/location-small-dark.svg'
import FilledVehicle from './icons/filled-vehicle.svg'
import FilledTrafficLights from './icons/filled-traffic-lights.svg'
import ticket from './icons/ticket.svg'
import filledTicket from './icons/filled-ticket.svg'
import discovery from './icons/discovery.svg'
import filledDiscovery from './icons/filled-discovery.svg'
import homeGrocery from './icons/home-grocery.svg'
import homeNomand from './icons/home-nomand.svg'
import homeTicket from './icons/home-ticket.png'
import homeTaxi from './icons/home-taxi.png'
import homeWallet from './icons/home-wallet.png'
import homeMyTehran from './icons/home-my-tehran.png'
import login from './icons/login.svg'
import otp from './icons/otp.svg'
import passwordInvisible from './icons/password-invisible.svg'
import passwordVisible from './icons/password-visible.svg'
import signup from './icons/signup.svg'
import signupForm from './icons/signup-form.svg'
import changeNumber from './icons/change-number.svg'
import addressDot from './icons/AddressDot.svg'
import taxiSuccess from './icons/taxi-success.svg'
import homeBackground from './icons/home-background.svg'
import profileFilledBlack from './icons/profile-filled-black.svg'
import familyProfile from './icons/profile-2user.svg'
import familyGroup from './icons/FamilyGroup.png'
import walletBlack from './icons/wallet-black.svg'
import ticketBlack from './icons/ticket-black.svg'
import groceryBlack from './icons/grocery-black.svg'
import taxiWhite from './icons/taxi-white.svg'
import logoShahrzadBlack from './icons/logo-shahrzad-black.svg'
import menuBlack from './icons/menu-black.svg'
import setting from './icons/setting.svg'
import exit from './icons/exit.svg'
import phoneBlack from './icons/phone-black.svg'
import arrowLeftBlack from './icons/arrow-left-black.svg'
import palette from './icons/palette.svg'
import trafficPlanBlack from './icons/traffic-plan-black.svg'
import calendarGrayLarge from './icons/calendar-gray-large.svg'
import flash from './icons/flash.svg'
import homeBlack from './icons/home-black.svg'
import infoSquare from './icons/info-square.svg'
import reloadPrimary from './icons/reload-primary.svg'
import downloadWhite from './icons/download-white.svg'
import document from './icons/document.svg'
import image from './icons/image.svg'
import imageLarge from './icons/image-large.svg'
import imageError from './icons/image-error.svg'
import tehranSubwayMap from './icons/tehran-subway-map.jpg'
import university from './icons/university.svg'
import school from './icons/school.svg'
import infoError from './icons/info-error.svg'
import ticketBlackSmall from './icons/ticket-black-small.svg'
import giftIcon from './icons/gift.svg'
import infoSquareGreen from './icons/Info-Square-green.svg'
import infoFillSuccess from './icons/Info-fill-success.svg'
import infoFillWarning from './icons/Info -Square-orange.svg'
import aboutShahrzad from './icons/aboutShahrzad.png'
import emptyWallet from './icons/wallet-empty.svg'
import timeSquare from './icons/time-square.svg'
import vector from './icons/vector.svg'
import swim from './icons/swimmimgPool.png'
import waterDrop from './icons/drop-water.svg'
import swimSuccess from './icons/swim-success.svg'
import store from './icons/store.svg'
import delivery from './icons/delivery.svg'
import transaction from './icons/transaction-background.svg'
import questions from './icons/questions.svg'
import blackGift from './icons/black-gift.svg'
import dotGray from './icons/dot-gray.svg'
import scanning from './icons/scanning.svg'
import physicalCard from './icons/physical-card.svg'
import filledDocument from './icons/filled-document.svg'
import work from './icons/work.svg'
import filledWork from './icons/filled-work.svg'
import card from './icons/card.svg'
import filledCard from './icons/filled-card.svg'
import wrench from './icons/wrench.svg'
import filledWrench from './icons/filled-wrench.svg'
import blueMinus from './icons/Blue-Minus.svg'
import filterPrimary from './icons/filter-primary.svg'
import filterWhite from './icons/filter-white.svg'
import walletOutlineWhite from './icons/wallet-outline-white.svg'
import infoSquareOutline from './icons/info-square-outline.svg'
import emptyTransaction from './icons/empty-transaction.svg'
import closeSquarePrimary from './icons/close-square-primay.svg'
import calendarPrimary from './icons/CalendarPrimary.svg'
import error404 from './icons/error404.svg'
import minusSquare from './icons/minus-square.png'
import plusSquare from './icons/plus-square.png'
import search from './icons/search.svg'
import cartWhite from './icons/cart-white.svg'
import basket from './icons/basket.svg'
import filledBasket from './icons/filled_basket.svg'
import surveyBanner from './icons/survey-banner.svg'
import surveyIcon from './icons/survey-icon.svg'
import map from './icons/map.png'
import successTick from './icons/success-tick.svg'
import emptyAddress from './icons/empty-address.svg'
import miladTowerShahrzadBlack from './icons/shahrzad-milad-logo.svg'
import tehranBackground from './icons/tehran-background.svg'
import lineSmall from './icons/line-small.svg'
import totalPointsBg from './icons/total-points-bg.svg'
import groceryPlaceholder from './icons/grocery-placeholder.png'
import star from './icons/star.svg'
import sendError from './icons/send-error.svg'
import sendSuccess from './icons/send-success.svg'
import receiveError from './icons/receive-error.svg'
import receiveSuccess from './icons/receive-success.svg'
import closeBlack from './icons/close-black.svg'
import locationLargePrimary from './icons/location-large-primary.svg'
import cashout from './icons/empty-cashout.svg'
import cart from './icons/cart.svg'
import filledCart from './icons/filled-cart.svg'
import market from './icons/market.svg'
import filledMarket from './icons/filled-market.svg'
import emptyOrder from './icons/empty-order.svg'
import emptyStore from './icons/empty-store.svg'
import Logout from './icons/Logout.svg'
import coinLarge from './icons/coin-large.svg'
import coinSmall from './icons/coin-small.svg'
import trophy from './icons/trophy.svg'
import infoSquarePrimary from './icons/info-square-primary.svg'
import platform1 from './icons/platform1.svg'
import platform2 from './icons/platform2.svg'
import platform3 from './icons/platform3.svg'
import listTop from './icons/list-top.svg'
import whiteLogin from './icons/white-login.svg'
import privacyIcon from './icons/security-safe.svg'
import ticketEmpty from './icons/TicketEmpty.svg'
import share from './icons/share.svg'
import BlueTicket from './icons/ticket-blue.svg'
import vpn from './icons/vpn.svg'
import networkFaile from './icons/network-connection-failure.svg'
import updateShahrzad from './icons/update.svg'
import tryAgain from './icons/Connectivity.svg'
import serverError from './icons/server-error.svg'
import fobidenAccess from './icons/forbidden-access.svg'
import illegaAccess from './icons/illegal-access.svg'
import pageNotFound from './icons/page-not-found.svg'
import invalidRequset from './icons/invalid-request.svg'
import timeOut from './icons/time-out.svg'
import notAvailable from './icons/notAvailable.svg'
import fiveZeroTwo from './icons/five-ziro-two-error.svg'
import errorWallet from './icons/Wallet-is-Empty.svg'
import PlusAroundBlue from './icons/plus-around-blue.svg'
import marker from './icons/marker.png'
import meat from './icons/meat.svg'
import filledMeat from './icons/filled-meat.svg'
import fullCapacity from './icons/full-capacity.svg'
import hasDelivery from './icons/has-delivery.svg'
import noDelivery from './icons/no-delivery.svg'
import hasDeliverySuccess from './icons/has-delivery-success.svg'
import noDeliveryWarning from './icons/no-delivery-warning.svg'
import employee from './icons/employee.svg'
import whiteWallet from './icons/white-wallet.svg'
import whiteTicket from './icons/white-ticket.svg'
import city from './icons/city.svg'
import circleInfo from './icons/Info-Circle.svg'
import scan from './icons/Scan.svg'
import inviteFriends from './icons/invite-friends.svg'
import copyButton from './icons/copy-button.svg'
import friends from './icons/friends.svg'
import starWhite from './icons/star-white.svg'
import qrBorder from './icons/QR-Code.svg'
import add from './icons/Add.svg'
import manzelatIcon from './icons/Manzelat-icon.svg'
import deliveryBoxes from './icons/Delivery-boxes.svg'
import deliveryBoxesWhite from './icons/Delivery-boxes-white.svg'
import searchNormal from './icons/search-normal.svg'
import searchNormalWhite from './icons/search-normal-white.svg'
import financialDiscrepanyModalImage from './icons/financial-discrepancy-modal-image.svg'
import deliveryCode from './icons/delivery-code.svg'
import redLocation from './icons/Red-Location.svg'
import bankCardRecieve from './icons/bank-card-recieve.svg'
import motor from './icons/Motor.svg'
import successMotor from './icons/success-motor.svg'
import orderDetail from './icons/order-detail.svg'
import storeDangerIcon from './icons/store-danger-icon.svg'
import userPrimaryIcon from './icons/user-primary-icon.svg'
import receiptItem from './icons/receipt-item.svg'
import receiptItemWhite from './icons/receipt-item-white.svg'
import spoonAndFork from './icons/spoon-and-fork.svg'
import successSpoonAndFork from './icons/success-spoon-and-fork.svg'
import deliveryHand from './icons/delivery-hand.svg'
import successDeliveryHand from './icons/success-delivery-hand.svg'
import outlineTickSquare from './icons/outline-tick-square.svg'
import successTickSquare from './icons/success-tick-square.svg'
import shoppingBasket from './icons/shopping-basket.svg'
import successShoppingBasket from './icons/success-shopping-basket.svg'
import checkFillCircle from './icons/check-fill-circle.svg'
import blankCircle from './icons/blank-circle.svg'
import arrowRightSquare from './icons/Arrow-Right-Square.svg'
import arrowLeftSquare from './icons/Arrow-Left-Square.svg'
import neshan from './icons/neshan.png'
import balald from './icons/balad.png'
import googleMaps from './icons/google-map.png'
import shahrzadWallet from './icons/shahrzad-wallet.svg'
import logo from './icons/logo.svg'
import reloadBlack from './icons/reload-black.svg'
import brownCircleInfo from './icons/brownCircleInfo.svg'
import successTransfer from './icons/success-transfer.svg'
import blueCircleInfo from './icons/blue-info-circle.svg'
import editBluePen from './icons/edit-blue.svg'
import collapseBlack from './icons/collapse-black.svg'
import receiptPrimary from './icons/receipt-primary.svg'
import Gps from './icons/GPS.svg'
import trash from './icons/trash.svg'
import festivalBanner from './icons/festival.jpg'
import barcodeIcon from './icons/barcode.svg'
import greenBike from './icons/green-bike.svg'
import blueBike from './icons/bike-empty-folder.svg'
import bluePhone from './icons/blue-Phone.svg'
import circleBlueInfo from './icons/blueInfo.svg'
import yellowWarning from './icons/yellowWarning.svg'
import travelRoad from './icons/travel-road.svg'
import profile from './icons/Profile.svg'
import stationMenu from './icons/station-menu.svg'
import inactiveTravelRoad from './icons/inactive-travel-road.svg'
import inactiveStation from './icons/inactive-stations.svg'
import plusBlackSquare from './icons/black-plus-square.svg'
import marketBlueOutline from './icons/market-blue-outline.svg'
import emptyItem from './icons/empty-item.svg'
import arrowDownBlack from './icons/arrow-down-black.svg'
import userProfile from './icons/user-profile.svg'
import walletProfile from './icons/wallet-profile.svg'
import userLevelProfile from './icons/user-level-profile.svg'
import civicClubProfile from './icons/civic-club-profile.svg'
import changeNumberProfile from './icons/change-number-profile.svg'
import exitRedProfile from './icons/exit-profile-red.svg'
import citizenshipCardProfile from './icons/citizenship-card-profile.svg'
import myGroupsProfile from './icons/my-groups-profile.svg'
import inviteFriendsProfile from './icons/invite-friends-profile.svg'

export const icons = {
  BACK: Back,
  STATION: station,
  STATION_ACTIVE: stationActive,
  ACCOUNT: account,
  ACCOUNT_ACTIVE: accountActive,
  RESERVATION_LIST: reservationList,
  RESERVATION_LIST_ACTIVE: reservationListActive,
  VEHICLE: vehicle,
  VEHICLE_ACTIVE: vehicleActive,
  MENU: menu,
  CLOSE: close,
  COLLAPSE: collapse,
  DELETE_RED: deleteRed,
  EDIT: edit,
  PRIMARY_EDIT: primaryEdit,
  CIRCLE_SUCCESS: circleSuccess,
  CIRCLE_INFO_YELLOW: circleInfoYellow,
  CALENDAR: calendar,
  EMPTY_FOLDER: emptyFolder,
  STATION_LARGE: stationLarge,
  CALENDAR_LARGE: calendarLarge,
  SUCCESS_IMAGE: successImage,
  FAIL_IMAGE: failImage,
  VEHICLE_LARGE: vehicleLarge,
  AVATAR: Avatar,
  VEHICLE_EXTRA_LARGE: vehicleExtraLarge,
  ARROW_LEFT_PRIMARY: arrowLeftPrimary,
  CALENDAR_GRAY: calendarGray,
  HOUR_GLASS: hourGlass,
  EMPTY_CALENDAR: emptyCalendar,
  LeftWhite: whiteLeft,
  IRAN: iran,
  CLOCK_SMALL: clockSmall,
  PHONE_SMALL: phoneSmall,
  LOCATION_SMALL: locationSmall,
  PHONE: phone,
  LOCATION: location,
  TRUCK: truck,
  CLOSE_SQUARE: closeSquare,
  TICK_SQUARE: tickSquare,
  ARROW_RIGHT: arrowRight,
  ARROW_LEFT: arrowLeft,
  TRAFFIC: getTurn,
  RED_LEFT: RedLeft,
  RED_WARNING: RedWarning,
  TWO_CIRCLES: TwoCircles,
  WARNING: Warning,
  EYE: Eye,
  WALLET_PRIMARY: walletPrimary,
  PLUS_PRIMARY: plusPrimary,
  PLUS_WHITE: plusWhite,
  GUIDE_CARD: guideCard,
  GUIDE_CARD_EZPAY: guideCardEzpay,
  REPEAT: repeat,
  HOME: Home,
  WALLET: Wallet,
  CALENDAR_WHITE: CalendarWhite,
  FILLED_HOME: FilledHome,
  FILLED_CALENDAR: FilledCalendar,
  FILLED_WALLET: FilledWallet,
  EMPTY_CARD: emptyCard,
  SUBWAY: subway,
  LOCATION_SQUARE: locationSquare,
  LOCATION_SMALL_DARK: locationSmallDark,
  FILLED_VEHICLE: FilledVehicle,
  FILLED_TRAFFIC_LIGHTS: FilledTrafficLights,
  TICKET: ticket,
  FILLED_TICKET: filledTicket,
  DISCOVERY: discovery,
  FILLED_DISCOVERY: filledDiscovery,
  HOME_GROCERY: homeGrocery,
  HOME_NOMAND: homeNomand,
  HOME_TICKET: homeTicket,
  HOME_TAXI: homeTaxi,
  HOME_WALLET: homeWallet,
  LOGIN: login,
  OTP: otp,
  PASSWORD_INVISIBLE: passwordInvisible,
  PASSWORD_VISIBLE: passwordVisible,
  SIGNUP: signup,
  SIGNUP_FORM: signupForm,
  CHANGE_NUMBER: changeNumber,
  ADDRESS_DOT: addressDot,
  TAXI_SUCCESS: taxiSuccess,
  HOME_BACKGROUND: homeBackground,
  PROFILE_FILLED_BLACK: profileFilledBlack,
  FAMILY_PROFILE: familyProfile,
  FAMILY_GROUP: familyGroup,
  EMPLOYEE: employee,
  WALLET_BLACK: walletBlack,
  TICKET_BLACK: ticketBlack,
  WHITE_WALLET: whiteWallet,
  WHITE_TICKET: whiteTicket,
  GROCERY_BLACK: groceryBlack,
  TAXI_WHITE: taxiWhite,
  LOGO_SHAHRZAD_BLACK: logoShahrzadBlack,
  MENU_BLACK: menuBlack,
  SETTING: setting,
  EXIT: exit,
  PHONE_BLACK: phoneBlack,
  ARROW_LEFT_BLACK: arrowLeftBlack,
  PALETTE: palette,
  TRAFFIC_PLAN_BLACK: trafficPlanBlack,
  CALENDAR_GRAY_LARGE: calendarGrayLarge,
  FLASH: flash,
  HOME_BLACK: homeBlack,
  INFO_SQUARE: infoSquare,
  RELOAD_PRIMARY: reloadPrimary,
  DOWNLOAD_WHITE: downloadWhite,
  DOCUMENT: document,
  IMAGE: image,
  IMAGE_LARGE: imageLarge,
  IMAGE_ERROR: imageError,
  TEHRAN_SUBWAY_MAP: tehranSubwayMap,
  UNIVERSITY: university,
  SCHOOL: school,
  INFO_ERROR: infoError,
  TICKET_BLACK_SMALL: ticketBlackSmall,
  RED_GIFT: giftIcon,
  TIME_SQUARE: timeSquare,
  INFO_SQUARE_GREEN: infoSquareGreen,
  INFO_FILL_SUCCESS: infoFillSuccess,
  INFO_FILL_WARNING: infoFillWarning,
  ABOUT_SHAHRZAD: aboutShahrzad,
  EMPTY_WALLET: emptyWallet,
  HOME_MY_TEHRAN: homeMyTehran,
  STORE: store,
  DELIVERY: delivery,
  Vector: vector,
  Swim: swim,
  WATER_DROP: waterDrop,
  SWIM_SUCCESS_PAYMENT: swimSuccess,
  MINUS_PRIMARY: minusPrimary,
  TRANSACTION_BACKGROUND: transaction,
  QUESTOINS: questions,
  BLACK_GIFT: blackGift,
  DOT_GRAY: dotGray,
  SCANNING: scanning,
  PHYSICAL_CARD: physicalCard,
  FILLED_DOCUMENT: filledDocument,
  WORK: work,
  FILLED_WORK: filledWork,
  CARD: card,
  FILLED_CARD: filledCard,
  WRENCH: wrench,
  FILLED_WRENCH: filledWrench,
  BLUE_MINUS: blueMinus,
  FILTER_PRIMARY: filterPrimary,
  FILTER_WHITE: filterWhite,
  WALLET_OUTLINE_WHITE: walletOutlineWhite,
  INFO_SQUARE_OUTINE: infoSquareOutline,
  EMPTY_TRANSACTION: emptyTransaction,
  EXIT_RED: exitRed,
  CLOSE_SQUARE_PRIMARY: closeSquarePrimary,
  CALENDAR_PRIMARY: calendarPrimary,
  ERROR404: error404,
  MINUS_SQUARE: minusSquare,
  PLUS_SQUARE: plusSquare,
  ADD: add,
  SEARCH: search,
  SEARCH_NORMAL: searchNormal,
  SEARCH_NORMAL_WHITE: searchNormalWhite,
  CART_WHITE: cartWhite,
  MARKET_PLACEHOLDER: marketPlaceholder,
  BASKET: basket,
  FILLED_BASKET: filledBasket,
  SURVEY_BANNER: surveyBanner,
  SURVEY_ICONS: surveyIcon,
  MAP: map,
  STAR: star,
  GROCERY_PLACEHOLDER: groceryPlaceholder,
  SEND_ERROR: sendError,
  SEND_SUCCESS: sendSuccess,
  RECEIVE_ERROR: receiveError,
  RECEIVE_SUCCESS: receiveSuccess,
  CLOSE_BLACK: closeBlack,
  LOCATION_LARGE_PRIMARY: locationLargePrimary,
  CASH_OUT: cashout,
  CART: cart,
  FILLED_CART: filledCart,
  MARKET: market,
  FILLED_MARKET: filledMarket,
  EMPTY_ORDER: emptyOrder,
  EMPTY_STORE: emptyStore,
  SUCCESS_TICK: successTick,
  EMPTY_ADDRESS: emptyAddress,
  LOGO_SHAHRZAD_MILAD: miladTowerShahrzadBlack,
  TEHRAN_BACKGROUND: tehranBackground,
  TOTAL_POINTS_BG: totalPointsBg,
  LOGOUT: Logout,
  LINE_SMALL: lineSmall,
  COIN_LARGE: coinLarge,
  TROPHY: trophy,
  COIN_SMALL: coinSmall,
  INFO_SQUARE_PRIMARY: infoSquarePrimary,
  PLATFORM1: platform1,
  PLATFORM2: platform2,
  PLATFORM3: platform3,
  LIST_TOP: listTop,
  COPY_PRIMARY: copyPrimary,
  WHITE_LOGIN: whiteLogin,
  PRIVACY_ICON: privacyIcon,
  DELETE_RED_FILL: deleteRedFill,
  CALENDAR_SMALL_DARK: calendarSmallDark,
  HEART: heart,
  RECYCLE: recycle,
  WARNING_RED: warningRed,
  FAIL: fail,
  CLOSE_SMALL_BLACK: closeSmallBlack,
  CIRCLE_PLUS: circlePlus,
  SEND_MESSAGE: send,
  GALLERY: gallery,
  NO_CHAT: noChat,
  ORANGE_INFO: orangeInfo,
  PURPLE_INFO: purpuleInfo,
  DEFAULT_INFO: defaultInfo,
  TICKET_EMPTY: ticketEmpty,
  SHARE: share,
  BLUE_TICKET: BlueTicket,
  PLUSE_AROUND_BLUE: PlusAroundBlue,
  VPN: vpn,
  NETWORK_FAILE: networkFaile,
  UPDATE_SHAHRZAD: updateShahrzad,
  TRY_AGAIN: tryAgain,
  SERVER_ERROR: serverError,
  FORBIDDEN_ACCESS: fobidenAccess,
  ILLEGAL_ACCESS: illegaAccess,
  PAGE_NOT_FOUND: pageNotFound,
  INVALID_REQUEST: invalidRequset,
  TIME_OUT: timeOut,
  NOT_AVAILABLE: notAvailable,
  FIVE_ZERO_TWO_ERROR: fiveZeroTwo,
  WALLET_IS_EMPTY: errorWallet,
  MARKER: marker,
  MEAT: meat,
  FILLED_MEAT: filledMeat,
  FULL_CAPACITY: fullCapacity,
  HAS_DELIVERY: hasDelivery,
  NO_DELIVERY: noDelivery,
  HAS_DELIVERY_SUCCESS: hasDeliverySuccess,
  NO_DELIVERY_WARNING: noDeliveryWarning,
  CITY: city,
  CIRCLE_INFO: circleInfo,
  SCAN: scan,
  INVITE_FRIENDS: inviteFriends,
  COPY_BUTTON: copyButton,
  FRIENDS: friends,
  STAR_WHITE: starWhite,
  QR_BORDER: qrBorder,
  MANZELAT_ICON: manzelatIcon,
  DELIVERY_BOXES: deliveryBoxes,
  DELIVERY_BOXES_WHITE: deliveryBoxesWhite,
  FINANCIAL_DISCREPANCY_MODAL_IMAGE: financialDiscrepanyModalImage,
  DELIVERY_CODE: deliveryCode,
  RED_LOCATION: redLocation,
  BANK_CARD_RECIEVE: bankCardRecieve,
  MOTOR: motor,
  SUCCESS_MOTOR: successMotor,
  ORDER_DETAIL: orderDetail,
  STORE_DANGER_ICON: storeDangerIcon,
  USER_PRIMARY_ICON: userPrimaryIcon,
  RECEIPT_ITEM: receiptItem,
  RECEIPT_ITEM_WHITE: receiptItemWhite,
  SPOON_AND_FORK: spoonAndFork,
  SUCCESS_SPOON_AND_FORK: successSpoonAndFork,
  DELIVERY_HAND: deliveryHand,
  SUCCESS_DELIVERY_HAND: successDeliveryHand,
  OUTLINE_TICK_SQUARE: outlineTickSquare,
  SUCCESS_TICK_SQUARE: successTickSquare,
  SHOPPING_BASKET: shoppingBasket,
  SUCCESS_SHOPPING_BASKET: successShoppingBasket,
  CHECK_FILL_CIRCLE: checkFillCircle,
  BLANK_CIRCLE: blankCircle,
  ARROW_LEFT_SQUARE: arrowLeftSquare,
  ARROW_RIGHT_SQUARE: arrowRightSquare,
  NESHAN_APP: neshan,
  BALAD_APP: balald,
  GOOGLE_MAP_APP: googleMaps,
  SHAHRZAD_WALLET: shahrzadWallet,
  MILAD_TOWER_LOGO: logo,
  RELOAD_BLACK: reloadBlack,
  BROWN_CIRCLE_INFO: brownCircleInfo,
  SUCCESS_TRANSFER: successTransfer,
  BLUE_CIRCLE_INFO: blueCircleInfo,
  EDIT_PEN: editBluePen,
  COLLAPSE_BLACK: collapseBlack,
  RECEIPT_PRIMARY: receiptPrimary,
  GPS: Gps,
  TRASH: trash,
  FESTIVAL_BANNER: festivalBanner,
  BARCODE: barcodeIcon,
  GREEN_BIKE: greenBike,
  BLUE_BIKE: blueBike,
  BLUE_PHONE: bluePhone,
  BLUE_INFO: circleBlueInfo,
  YELLOW_WARNING: yellowWarning,
  TRAVEL_ROAD: travelRoad,
  PROFILE: profile,
  STATION_MENU: stationMenu,
  INACTIVE_TRAVEL_ROAD: inactiveTravelRoad,
  INACTIVE_STATIONS: inactiveStation,
  PLUSE_BLACK_SQUARE: plusBlackSquare,
  MARKET_BLUE_OUTLINE: marketBlueOutline,
  EMPTY_ITEM: emptyItem,
  ARROW_DOWN_BLACK: arrowDownBlack,
  USER_PROFILE: userProfile,
  WALLET_PROFILE: walletProfile,
  USER_LEVEL_PROFILE: userLevelProfile,
  CIVIC_CLUB_PROFILE: civicClubProfile,
  CHANGE_NUMBER_PROFILE: changeNumberProfile,
  EXIT_RED_PROFILE: exitRedProfile,
  CITIZENSHIP_CARD_PROFILE: citizenshipCardProfile,
  MY_GROUPS_PROFILE: myGroupsProfile,
  INVITE_FRIENDS_PROFILE: inviteFriendsProfile,
}
